import dynamic from 'next/dynamic';

import type { ProductCarouselSectionProps } from 'src/components/sections/ProductCarouselSection/ProductCarouselSection';
import { fetchUnifiedProducts } from 'src/services/unified-product-service/fetchUnifiedProducts';
import type { SectionRenderer } from 'src/types/Section';
import type { AsyncTransformer } from 'src/types/Transformer';
import { lazyLoadImages } from 'src/utils/images';
import type { ProductCarouselContentSection } from './types';
import { getProductsValidationErrors } from './validation';

/* istanbul ignore next */
export const renderer: SectionRenderer<ProductCarouselSectionProps> =
  dynamic<ProductCarouselSectionProps>(() =>
    import('src/components/sections/ProductCarouselSection/ProductCarouselSection').then(
      (mod) => mod.ProductCarouselSection,
    ),
  );

const getProductCodes = (products: { product_code: string }[]) =>
  products.map(({ product_code }) => Number(product_code));

export const transformer: AsyncTransformer<
  ProductCarouselContentSection,
  ProductCarouselSectionProps
> = async ({ _metadata, heading, products, tracking_title }, { pageConfig, positionMetadata }) => {
  const result = await fetchUnifiedProducts(getProductCodes(products));
  const renderableProducts = (result?.products ?? []).filter((product) => product.purchasable);
  const errors = getProductsValidationErrors(getProductCodes(products), result, renderableProducts);

  return {
    uid: _metadata.uid,
    props: {
      heading,
      products: renderableProducts,
      pageType: pageConfig.pageType,
      trackingTitle: tracking_title,
      lazyImages: lazyLoadImages(positionMetadata.position),
    },
    errors,
  };
};
